import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cbbcd1b8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cbbcd1b8&prod&scoped=true&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=cbbcd1b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbcd1b8",
  null
  
)

export default component.exports